{
  "drawer": {
    "title": "Record payment",
    "subtitle": {
      "invoice": "Record a payment for invoice {{code}}",
      "adhoc": "Record a revenue entry not tied to an invoice"
    },
    "field": {
      "amount": "Amount *",
      "amountPlaceholder": "e.g. 2,000,000",
      "date": "Date *",
      "source": "Source *",
      "content": "Note",
      "contentPlaceholder": {
        "CASH": "e.g. Cash from customer Hùng",
        "MANUAL_BANK": "e.g. Manual bank transfer",
        "ECOMMERCE": "e.g. Shopee order #123 / Lazada payout 2026-05",
        "OTHER": "Short description..."
      },
      "client": "Client",
      "noClient": "— No client —"
    },
    "source": {
      "CASH": "Cash",
      "MANUAL_BANK": "External bank transfer",
      "ECOMMERCE": "Marketplace",
      "OTHER": "Other"
    },
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving..."
  },
  "toast": {
    "paid": "Invoice fully paid",
    "partial": "Partial payment recorded",
    "adhoc": "Revenue recorded",
    "deleted": "Payment deleted",
    "error": "Something went wrong, try again"
  },
  "inbox": {
    "title": "Unmatched payments",
    "subtitle": "Bank transfers that couldn't be matched to an invoice — link them manually or ignore.",
    "consequence": "A transfer that uses the QR reference matches itself; only the ones that differ land here.",
    "loading": "Loading...",
    "loadError": "Failed to load unmatched payments",
    "empty": "No unmatched payments",
    "emptyBody": "Every transfer has been matched to an invoice.",
    "column": {
      "amount": "Amount",
      "content": "Transfer content",
      "date": "Date",
      "confidence": "Match status",
      "actions": "Actions"
    },
    "confidence": {
      "needs_confirmation": "Possible amount match",
      "unmatched": "No matching invoice found"
    },
    "action": {
      "link": "Link to invoice",
      "ignore": "Ignore",
      "more": "More actions"
    },
    "linkDialog": {
      "title": "Link to invoice",
      "description": "Choose an outstanding invoice to link this {{amount}} payment to.",
      "select": "Select an invoice...",
      "unknownClient": "Unknown client",
      "empty": "No invoices are awaiting payment (PENDING/PARTIAL)",
      "cancel": "Cancel",
      "confirm": "Link"
    },
    "ignoreDialog": {
      "title": "Ignore this payment?",
      "description": "This transfer will be excluded from revenue and the bookkeeping ledger, and removed from the unmatched list. Use this when it isn't tuition income.",
      "cancel": "Cancel",
      "confirm": "Ignore"
    },
    "toast": {
      "linked": "Payment linked to invoice",
      "ignored": "Payment ignored"
    },
    "navLink": "Unmatched payments"
  }
}
